import { useTranslation } from 'react-i18next';

import type { ReactionType } from '../types';

export const EMOJI_MAP: Record<ReactionType, string> = {
  like: '\uD83D\uDC4D',
  fire: '\uD83D\uDD25',
  heart: '\u2764\uFE0F',
  smooth: '\uD83C\uDFB6',
};

export const ACTIVE_COLORS: Record<ReactionType, string> = {
  like: 'var(--color-primary-500)',
  fire: '#FF6D00',
  heart: '#E53935',
  smooth: '#00897B',
};

interface ReactionButtonProps {
  type: ReactionType;
  count: number;
  isActive: boolean;
  onClick: () => void;
  disabled?: boolean;
}

export function ReactionButton({
  type,
  count,
  isActive,
  onClick,
  disabled = false,
}: ReactionButtonProps) {
  const { t } = useTranslation();

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      aria-label={t(`feed.reaction_${type}`)}
      aria-pressed={isActive}
      className="flex items-center gap-1 px-2.5 py-1 rounded-lg font-semibold text-xs transition-all active:scale-90 disabled:opacity-50 disabled:cursor-not-allowed select-none"
      style={{
        backgroundColor: isActive ? ACTIVE_COLORS[type] : 'rgba(255,255,255,0.45)',
        color: isActive ? '#ffffff' : '#1E293B',
        border: `1px solid ${isActive ? ACTIVE_COLORS[type] : 'rgba(255,255,255,0.2)'}`,
        boxShadow: isActive ? 'none' : '0 1px 2px rgba(0,0,0,0.05)',
      }}
    >
      <span className="text-sm leading-none">{EMOJI_MAP[type]}</span>
      {count > 0 && <span>{count}</span>}
    </button>
  );
}
